import data from './images.generated.json';

/** One exported illustration: a WebP with alpha in two sizes (see pipeline/images/export.py). */
export interface Picture {
  src: string;
  small: string;
  width: number;
  height: number;
  /** Width of the small file; its height keeps the same aspect. */
  smallWidth: number;
  alt: string;
  /** A full-bleed scene with no transparency: the app rounds its corners and draws no outline. */
  opaque?: boolean;
}

const pictures = (data as { images: Record<string, Picture> }).images;

/** The illustration for a phrase, lesson or cover id, or null when it has none yet. */
export function pictureOf(id: string): Picture | null {
  return pictures[id] ?? null;
}

export function allPictures(): Picture[] {
  return Object.values(pictures);
}
